<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import type { VariantProps } from 'tailwind-variants';
	import { tv } from '../tv';
	import { CONTAINER_COLOR_VARIANTS } from '../variants';

	export const modalVariants = tv({
		base: 'flex h-full w-full animate-rise-5 flex-col overflow-hidden rounded-r400 border-b300 border-solid border-(--v-container-line) bg-(--v-container) text-(--v-on-container) shadow-e300',
		variants: {
			variant: CONTAINER_COLOR_VARIANTS,
			size: {
				'300': 'max-h-modal-height-300 max-w-modal-width-300',
				'400': 'max-h-modal-height-400 max-w-modal-width-400',
				'500': 'max-h-modal-height-500 max-w-modal-width-500'
			},
			flexHeight: { true: 'h-[unset]' }
		},
		defaultVariants: { variant: 'Surface', size: '400' }
	});

	export interface ModalProps
		extends Omit<HTMLAttributes<HTMLElement>, 'class'>, VariantProps<typeof modalVariants> {
		as?: string;
		children?: Snippet;
		class?: ClassValue;
		ref?: HTMLElement | null;
	}
</script>

<script lang="ts">
	let {
		as = 'div',
		children,
		class: className,
		flexHeight,
		ref = $bindable(null),
		size,
		variant,
		...rest
	}: ModalProps = $props();
</script>

<svelte:element
	this={as}
	bind:this={ref}
	class={[modalVariants({ flexHeight, size, variant }), className]}
	{...rest}
>
	{@render children?.()}
</svelte:element>
